import React from 'react';

// Deterministic color per name
const COLORS = [
  '#2E66E0', '#6D4AEA', '#0A776E', '#B84209', '#C2185B', '#A84F06', '#147D54', '#64748B',
];

function colorForName(name: string): string {
  let hash = 0;
  for (let i = 0; i < name.length; i++) {
    hash = name.charCodeAt(i) + ((hash << 5) - hash);
  }
  return COLORS[Math.abs(hash) % COLORS.length];
}

interface AvatarInitialsProps {
  name: string;
  size?: number;
  ring?: 'green' | 'none';
  badge?: boolean; // ✦ orb badge
}

export function AvatarInitials({ name, size = 36, ring = 'none', badge = false }: AvatarInitialsProps) {
  const parts = name.trim().split(/\s+/);
  const initials = parts.length >= 2
    ? (parts[0][0] + parts[parts.length - 1][0]).toUpperCase()
    : name.slice(0, 2).toUpperCase();

  const color = colorForName(name);
  const fontSize = size * 0.35;

  return (
    <div className="relative flex-shrink-0" style={{ width: size, height: size }}>
      <div
        className="w-full h-full rounded-full flex items-center justify-center font-semibold text-white"
        style={{ background: color, fontSize }}
      >
        {initials}
      </div>
      {ring === 'green' && (
        <div
          className="absolute inset-[-2px] rounded-full border-2"
          style={{ borderColor: '#159662' }}
        />
      )}
      {badge && (
        <div
          className="absolute bottom-[-2px] right-[-2px] w-[12px] h-[12px] rounded-full flex items-center justify-center"
          style={{ background: 'linear-gradient(135deg, #8F6BFF 0%, #4A63E8 100%)' }}
        >
          <span style={{ fontSize: 6, color: 'white' }}>✦</span>
        </div>
      )}
    </div>
  );
}
